import { render } from "./notFound.vue?vue&type=template&id=6d6d565e&scoped=true"
import script from "./notFound.js?vue&type=script&lang=js"
export * from "./notFound.js?vue&type=script&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=6d6d565e&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6d565e"]])

export default __exports__